<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="1290px"
    :close-on-click-modal="false"
    :show-close="false"
    @open="onModalOpen"
    @close="onModalClose"
  >
    <template slot="title">
      <h2 class="dialog-title">
        <span>{{ title }}</span>
        <el-button v-if="multiline && !isMediaTag" type="text" @click="clearCurRow">清空全部</el-button>
      </h2>
    </template>

    <ElForm class="elementui-common-form-styles" v-highlight label-width="60" inline @submit.native.prevent>
      <ElFormItem label="素材类型">
        <ElSelect v-model="queryForm.imgType" style="width: 80px" :popper-append-to-body="false" @change="qureyAction">
          <ElOption :value="-1" :key="-1" label="不限"></ElOption>
          <ElOption :value="1" :key="1" label="图片"></ElOption>
          <ElOption :value="2" :key="2" label="视频"></ElOption>
          <ElOption :value="8" :key="8" label="组图"></ElOption>
        </ElSelect>
      </ElFormItem>

      <slot name="tag-select" :qureyAction="qureyAction" :queryForm="queryForm"></slot>

      <ElFormItem label="上传时间">
        <el-date-picker
          v-model="queryForm.uploadtime"
          type="daterange"
          :picker-options="datetimeOption"
          :append-to-body="false"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 220px"
          value-format="yyyy-MM-dd"
          @change="qureyAction"
        >
        </el-date-picker>
      </ElFormItem>
      <ElFormItem label="设计者">
        <el-select
          v-model="queryForm.opId"
          style="width: 100px"
          filterable
          clearable
          placeholder="全部"
          @change="qureyAction"
          :popper-append-to-body="false"
        >
          <el-option v-for="label in PTOM_USERS" :key="label.id" :value="label.id" :label="label.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem>
        <ElInput
          ref="search"
          v-model="queryForm.keyword"
          placeholder="请输入素材名称"
          style="width: 210px"
          clearable
          @keyup.enter.native="qureyAction"
        >
          <i slot="append" @click="qureyAction" class="el-icon-search"></i>
        </ElInput>
      </ElFormItem>

      <ElFormItem class="bg-transparent">
        <el-button type="primary" @click="qureyAction">查询</el-button>
      </ElFormItem>
    </ElForm>
    <el-table
      v-loading="tableLoading"
      class="common-el-table-styles"
      border
      stripe
      ref="tableMaterial"
      :data="materialData"
      :height="420"
      row-key="imageId"
      highlight-current-row
      @selection-change="onSelectionChange"
      @current-change="onCurrentChange"
    >
      <el-table-column v-if="multiline" reserve-selection row-key="imageId" :selectable="selectableFn" type="selection" width="39">
      </el-table-column>

      <el-table-column v-for="col in columns" :key="col.key" :prop="col.key" :label="col.title" :width="col.width" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <div style="text-align: center" v-if="col.key === 'addr'">
            <el-image @click="materialPreview(row)" style="height: 60px" :src="row.cover"> </el-image>
          </div>

          <div v-if="col.key === 'labelNames'">
            <span v-if="labelType === LABEL_TYPES.MATERIAL_STYLE_LABEL">{{ row.imageStyle2LabelNames }}</span>
            <span v-else>{{ row.labelNames }}</span>
          </div>

          <span v-else>{{ row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager">
      <el-pagination
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="total"
        :page-sizes="[30, 50, 100, 200]"
        @current-change="getData"
        @size-change="qureyAction"
        layout="total,sizes, prev, pager, next, jumper"
        background
      >
      </el-pagination>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="asyncSelect" v-if="showConfirmBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import moment from 'moment'
import { cols } from './const.js'
import { isArray, trim, timeout } from '@/common/js/utils'
import { getMaterialDataNoAuth, getSubMaterialData } from '@/api/material.model.js'
import { initPageData, PTOM_USERS, SYS_TAGS } from '@/data/global-opts'
import { LABEL_TYPES } from '@/views/material/tags/const'

const PAGE_REQUIRED_OPTS = initPageData([PTOM_USERS, SYS_TAGS])

const prevDate = moment().subtract(3, 'years').format('YYYY-MM-DD')
const now = moment().format('YYYY-MM-DD')

export default {
  name: 'pickMaterial',
  props: {
    value: {
      type: Boolean
    },
    type: {
      type: Number
    },
    // 标签类型
    labelType: {
      type: Number
    },
    multiline: {
      type: Boolean
    },
    rowLabelId: {
      // 素材样式级联model需要接受array类型
      type: [Number, Array]
    },
    selection: {
      type: Array,
      default() {
        return []
      }
    },
    // src/views/material/mediatags/list.vue
    isMediaTag: {
      type: Boolean,
      default: false
    },
    excludeMediaTagId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    LABEL_TYPES() {
      return LABEL_TYPES
    },
    videoSourceData() {
      return this.SYS_TAGS.filter((item) => {
        return item.labelType === LABEL_TYPES.THREED_LABEL
      })
    },
    labelData() {
      return this.SYS_TAGS.filter((item) => {
        return item.labelType === LABEL_TYPES.CONTENT_LABEL
      })
    },

    dialogVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    title() {
      if (this.multiline) {
        const count = this.selectedRows?.length || 0
        return `选择素材列表（已选${count}个）`
      } else return '选择素材列表'
    },

    isMediaTagAndSelectable() {
      // 媒体素材标签弹窗且是查看状态时不显示确认按钮
      return this.isMediaTag && !!this.excludeMediaTagId
    },
    showConfirmBtn() {
      if (!this.isMediaTag) return true
      return this.isMediaTagAndSelectable
    }
  },
  data() {
    return {
      tableLoading: null, // 请求状态
      total: 0,
      pageIndex: 1,
      pageSize: 30,
      queryForm: {
        keyword: '',
        imgType: this.type || -1,
        opId: null,
        labelId: [], // 内容标签，3d视频源标签专用
        mediaTagId: '', // 媒体标签专用
        // 在src/views/material/tags/Tags.vue 文件 素材样式el-cascader使用
        imageStyles: [],
        // src/views/material/mediatags/list.vue 媒体素材标签使用
        typeLabelIds: [],
        uploadtime: this.isMediaTag ? [] : [prevDate, now] // 初始上传时间
      },
      columns: cols,
      materialData: [],
      selectedRows: null,
      datetimeOption: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  methods: {
    selectableFn() {
      if (!this.isMediaTag) return true
      return this.isMediaTagAndSelectable
    },
    getData() {
      const { uploadtime, labelId, imageStyles, typeLabelIds, mediaTagId, opId, keyword, imgType } = this.queryForm
      const [beginTime, endTime] = uploadtime || ['', '']

      const imageStyleIds = imageStyles.length ? imageStyles.map((i) => i.slice(-1)).flat() : []
      const labelIdsStr = [labelId, imageStyleIds, typeLabelIds]
        .filter((i) => Array.isArray(i))
        .flat()
        .join(',')

      const params = {
        pageId: this.pageIndex,
        pageSize: this.pageSize,
        designerId: opId,
        imageName: keyword?.trim() || '',
        type: imgType,
        labelIdsStr,
        beginTime,
        endTime
      }

      if (this.isMediaTag) {
        // 媒体素材标签传tagId
        params.tagId = mediaTagId
        if (this.excludeMediaTagId) {
          params.excludeTagId = this.excludeMediaTagId
        }
      }

      if (this.tableLoading) return

      this.tableLoading = true
      this.materialData = []
      ;(this.isMediaTag ? getSubMaterialData(params) : getMaterialDataNoAuth(params))
        .then((data) => {
          if (data) {
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              const checkIds = this.multiline && Array.isArray(this.selectedRows) ? this.selectedRows.map((row) => row.imageId) : []
              const checkedImageIdList = []

              this.materialData = list.map((ret) => {
                if (ret.coverUrl && ret.coverUrl.indexOf(',') > -1) {
                  const imgs = ret.coverUrl.split(',')
                  ret.double = imgs.length === 2
                  ret.multiple = imgs.length > 2
                  ret.cover = imgs[0]
                } else {
                  ret.cover = ret.coverUrl
                }

                if (checkIds.includes(ret.imageId)) {
                  checkedImageIdList.push(ret.imageId)
                }

                return {
                  ...ret,
                  uploadTime: moment(ret.uploadTime).format('YYYY-MM-DD HH:mm:ss'),
                  video: ret.imgType === 2
                }
              })

              this.$nextTick(() => {
                this.materialData.forEach((ret) => {
                  if (this.isMediaTag && !this.excludeMediaTagId) {
                    this.$refs.tableMaterial.toggleRowSelection(ret, true)
                  } else {
                    if (checkedImageIdList.includes(ret.imageId)) {
                      this.$refs.tableMaterial.toggleRowSelection(ret, true)
                    }
                  }
                })
              })

              this.total = total_number || 0
            }
          }
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    asyncSelect() {
      const validCurrentRow = this.multiline
        ? isArray(this.selectedRows) && this.selectedRows.length
        : Boolean(Object.keys(this.selectedRows[0]).length)

      // 多个选择处理
      if (this.multiline) {
        if (validCurrentRow) {
          this.$emit('on-select', this.selectedRows)
          this.dialogVisible = false
        } else {
          this.$confirm('您未选择一个素材，确定要清空素材吗？', '系统提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$emit('on-select', this.selectedRows)
              this.dialogVisible = false
            })
            .catch(() => {})
        }
      } else {
        // 素材上传绑定老素材智能选择单个
        if (validCurrentRow) {
          this.$emit('on-select', this.selectedRows[0])
          this.dialogVisible = false
        } else {
          this.$Message.warning('至少选择一个素材')
        }
      }
    },
    onCurrentChange(row) {
      if (this.multiline) return
      this.selectedRows = [row]
    },
    onSelectionChange(selectedRows) {
      if (!isArray(selectedRows)) {
        this.selectedRows = selectedRows
        return
      }

      const currentPageSelectedIds = new Set(selectedRows.map((item) => item.imageId))
      const unselectedIdsOnCurrentPage = new Set(
        this.materialData.filter((item) => !currentPageSelectedIds.has(item.imageId)).map((item) => item.imageId)
      )
      const historySelection = isArray(this.selectedRows) ? this.selectedRows : []
      const retainedSelection = historySelection.filter((item) => !unselectedIdsOnCurrentPage.has(item.imageId))
      const mergedSelection = [...retainedSelection, ...selectedRows]
      const uniqueSelection = []
      const seenImageIds = new Set()

      mergedSelection.forEach((item) => {
        if (seenImageIds.has(item.imageId)) return
        seenImageIds.add(item.imageId)
        uniqueSelection.push(item)
      })

      this.selectedRows = uniqueSelection
    },
    onTableRowSelect(selection, row) {
      console.log('selection output: ', selection)
    },
    clearCurRow() {
      this.selectedRows = []
      this.$refs.tableMaterial.clearSelection()
    },
    onModalClose() {
      this.pageIndex = 1
      this.total = 0
      this.queryForm.keyword = ''
      this.queryForm.opId = ''
      this.queryForm.labelId = []
      this.queryForm.imageStyles = []
      this.queryForm.typeLabelIds = []
      this.queryForm.mediaTagId = ''
      this.queryForm.imgType = this.type || -1
      this.queryForm.uploadtime = this.isMediaTag ? [] : [prevDate, now]
      this.selectedRows = undefined
      this.materialData = []
      this.$emit('close')
      this.clearCurRow()
    },
    onModalOpen(val) {
      if (typeof this.rowLabelId !== 'undefined') {
        if (this.isMediaTag) {
          this.queryForm.mediaTagId = this.rowLabelId
        } else {
          // 素材样式为级联数组
          if (Array.isArray(this.rowLabelId)) {
            this.queryForm.imageStyles = this.rowLabelId
          } else {
            // 3d、内容标签为一维数组
            this.queryForm.labelId = [this.rowLabelId]
          }
        }
      } else {
        this.queryForm.labelId = []
        this.queryForm.mediaTagId = ''
      }
      this.multiline && (this.selectedRows = JSON.parse(JSON.stringify(this.selection)))
      if (this.type) {
        this.queryForm.imgType = this.type
      }
      this.getData()
    },

    qureyAction() {
      this.pageIndex = 1
      this.getData()
    },
    materialPreview(param) {
      const { video, videoUrl } = param
      this.$Gallery.open({ src: param.cover, video, videoUrl })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding-bottom: 6px;
  padding-top: 6px;
}
.pager {
  text-align: right;
  padding: 5px 0;
}

.dialog-title {
  line-height: 20px;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
